import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const MyComments = ()=>{
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: "MyComments placeholder"
    });
};
export default MyComments;
